import type { ViewComponent } from "@frui.ts/views";
import type SubLedgerNewReportViewModel from "../../../../viewModels/finance/subLedger/SubLedgerNewReportViewModel";
import { observer } from "mobx-react-lite";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import DateRangeInputControl from "../../../../controls/dateRangeInput";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import AdvancedInput, { Transformation } from "@edaz/edazkit/controls/AdvancedInput";
import React from "react";
import { Input } from "@frui.ts/bootstrap";

export const MainParameters: ViewComponent<SubLedgerNewReportViewModel> = observer(({ vm }) => {
  return (
    <div style={{ paddingBottom: "2.5rem" }}>
      <h5>{vm.translate("mainParameters.name")}</h5>

      <div className="row">
        <Form.Group as={Col} lg={4} xl={4}>
          <Form.Label>{vm.translate("mainParameters.createdDate")}</Form.Label>
          <DateRangeInputControl
            target={vm.filter}
            property="createdDate"
            onValueChanged={() => vm.validateDateRange(vm.filter, "createdDate")}
          />
        </Form.Group>

        <Form.Group as={Col} lg={4} xl={4}>
          <Form.Label>{vm.translate("mainParameters.accountingDate")}</Form.Label>
          <DateRangeInputControl
            target={vm.filter}
            property="accountingDate"
            disabled={vm.filter.accountingPeriod !== undefined}
            onValueChanged={() => vm.validateDateRange(vm.filter, "accountingDate")}
          />
        </Form.Group>

        <Form.Group as={Col} md={6} lg={4} xl={2}>
          <Form.Label>{vm.translate("mainParameters.accountingPeriod")}</Form.Label>
          <AdvancedSelect
            target={vm.filter}
            property="accountingPeriod"
            placeholder={vm.translate("mainParameters.accountingPeriod")}
            allowEmpty={true}
            disabled={vm.filter.accountingDate !== undefined}
            items={vm.accountingPeriodOptions}
          />
        </Form.Group>

        <Form.Group as={Col} md={6} lg={4} xl={2}>
          <Form.Label>{vm.translate("mainParameters.sequenceName")}</Form.Label>
          <AdvancedInput
            transformation={Transformation.UpperCased}
            target={vm.filter}
            placeholder={vm.translate("mainParameters.sequenceName")}
            property="sequenceName"
          />
        </Form.Group>
      </div>

      <div className="row">
        <Form.Group as={Col} lg={4} xl={4}>
          <Form.Label>{vm.translate("mainParameters.sequenceNumber")}*</Form.Label>
          <Input
            target={vm.filter}
            property="sequenceNumber"
            placeholder={vm.translate("mainParameters.sequenceNumber")}
            type="number"
          />
        </Form.Group>

        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("mainParameters.credit")}</Form.Label>
          <Input target={vm.filter} property="credit" placeholder={vm.translate("mainParameters.credit")} type="number" />
        </Form.Group>

        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("mainParameters.debit")}</Form.Label>
          <Input target={vm.filter} property="debit" placeholder={vm.translate("mainParameters.debit")} type="number" />
        </Form.Group>

        <Form.Group as={Col} lg={4} xl={4}>
          <Form.Label>{vm.translate("mainParameters.documentHeaderDescription")}</Form.Label>
          <Input
            target={vm.filter}
            property="documentHeaderDescription"
            placeholder={vm.translate("mainParameters.documentHeaderDescription")}
          />
        </Form.Group>
      </div>

      <div className="row">
        <Form.Group as={Col} lg={4} xl={4}>
          <Form.Label>{vm.translate("mainParameters.documentRowDescription")}</Form.Label>
          <Input
            target={vm.filter}
            property="documentRowDescription"
            placeholder={vm.translate("mainParameters.documentRowDescription")}
          />
        </Form.Group>

        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("mainParameters.papAnalyticBreakdown")}</Form.Label>
          <Input
            target={vm.filter}
            property="papAnalyticBreakdown"
            placeholder={vm.translate("mainParameters.papAnalyticBreakdown")}
          />
        </Form.Group>

        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("mainParameters.papTransaction")}</Form.Label>
          <Input target={vm.filter} property="papTransaction" placeholder={vm.translate("mainParameters.papTransaction")} />
        </Form.Group>

        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("mainParameters.partnerBalance")}</Form.Label>
          <Input target={vm.filter} property="partnerBalance" placeholder={vm.translate("mainParameters.partnerBalance")} />
        </Form.Group>

        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("mainParameters.analyticAccount")}</Form.Label>
          <Input target={vm.filter} property="analyticAccount" placeholder={vm.translate("mainParameters.analyticAccount")} />
        </Form.Group>
      </div>

      <div className="row">
        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("mainParameters.syntheticAccount")}</Form.Label>
          <Input target={vm.filter} property="syntheticAccount" placeholder={vm.translate("mainParameters.syntheticAccount")} />
        </Form.Group>

        <Form.Group as={Col} lg={4} xl={4}>
          <Form.Label>{vm.translate("mainParameters.paragraph")}</Form.Label>
          <Input target={vm.filter} property="paragraph" placeholder={vm.translate("mainParameters.paragraph")} />
        </Form.Group>

        <Form.Group as={Col} lg={4} xl={4}>
          <Form.Label>{vm.translate("mainParameters.article")}</Form.Label>
          <Input target={vm.filter} property="article" placeholder={vm.translate("mainParameters.article")} />
        </Form.Group>
      </div>
    </div>
  );
});
